import { useEffect } from 'react'

import { Popover } from '@verbit-ai/verbit-ui-library'

import { useLanguage } from 'src/contexts/LanguageContext'

import { LanguageSelectProps } from './types'
import { LanguagesList } from './LanguagesList'

export const LANGUAGE_SELECT_CLASSNAME = 'language-select'

export const LanguageSelect = (props: LanguageSelectProps) => {
    const { isOpen, onOpen, onClose, children } = props

    // close the popover when the language is changed,
    // because changing the language might lead to Insights panel being shown / hidden,
    // which shifts the layout, and popover doesn't follow it and stays floating,
    // separated the button that opened it
    const { requestedLanguageCode } = useLanguage()
    useEffect(() => {
        onClose()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requestedLanguageCode])

    return (
        <Popover
            isOpen={isOpen}
            onOpen={onOpen}
            onClose={onClose}
            triggerEl={children}
            trigger="click"
            placement="bottom-start"
            boxShadow="verbit_floating_action_button_shadow"
            contentWidth="unset">
            <LanguagesList />
        </Popover>
    )
}
